/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{height:100%;width:100%}.card[_ngcontent-%COMP%]{border-bottom:1px solid rgba(65,65,65,.1);font-size:18px;background-color:#fff;padding:20px 16px}.icon-arrow[_ngcontent-%COMP%]{position:absolute;right:8px;color:rgba(65,65,63,.2)}"];
export { styles as styles };
